module.exports = __webpack_public_path__ + "img/harmony_05.6dd492fa.jpg";